import html from "./ConsentReviewStep.html"
import SignaturePad from "signature_pad"
import "../SurveyReactComponent"
import DOMPurify from "dompurify";
import { getConsentMarkdownAsForm, getSignatureDate, getTypedNameFormItems } from "../../../components/Survey/Util/consent";
import { renderFormStepToHtml } from "../../../components/Survey/Components/FormStepToHtml/FormStepToHtml";

var module = angular.module("ResearchKitApplicationModule");

module.directive("consentReviewStep",
	["$window", "$timeout", function ($window, $timeout) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			},
			link: function (scope, iElement, iAttrs, controller) {
				var resetIframeHeight = function () {
					var position = $(iElement).find(".review-frame-wrapper").position();
					var footerHeight = $(iElement).find(".toolbar").outerHeight();
					var targetHeight = $(iElement).parents(".current-survey-content").height() - position.top - footerHeight;
					$(iElement).find(".review-frame-wrapper").height(targetHeight);
				}

				scope.$watch("stepManager", function () {
					if (scope.stepManager.surveyManager.getMode() != "Design") {
						$timeout(resetIframeHeight);
					}
				});

				if (scope.stepManager.surveyManager.getMode() != "Design") {
					$($window).on("resize", resetIframeHeight);
				}
			}
		};
	}]
);

module.controller("consentReviewStepController", ["$scope", "$sce", "$element", "$translate", "$timeout",
	function ($scope, $sce, $element, $translate, $timeout) {

		var self = this;

		$scope.$on('nextStackStep', function () {
			if ($scope.stepManager.consentReviewStepIndex == $scope.stepManager.getPages().length - 1) {
				$scope.stepManager.consentReviewStepIndex = 0;
			} else {
				$scope.stepManager.consentReviewStepIndex++;
			}
		});

		$scope.$on('previousStackStep', function () {
			if ($scope.stepManager.consentReviewStepIndex == 0) {
				$scope.stepManager.consentReviewStepIndex = $scope.stepManager.getPages().length - 1;
			} else {
				$scope.stepManager.consentReviewStepIndex--;
			}
		});

		$scope.trustAsHtml = function (value) { return $sce.trustAsHtml(value); };

		$scope.$watch('stepManager.step', function (newValue) {
			if (newValue !== null) {
				$scope.initalize();
			}
		})

		$scope.$watch('stepManager.consentReviewStepIndex', function (newValue) {
			var currentPage = $scope.stepManager.currentPage();
			var pageSubStepIdentifiers = {
				"Review": "consent_agreement",
				"Name": "consent_name",
				"Signature": "consent_signature"
			};
			if (pageSubStepIdentifiers[currentPage]) {
				$scope.stepManager.surveyManager.trackSubStepViewed($scope.stepManager.step.identifier, pageSubStepIdentifiers[currentPage], newValue);
			}
		});

		$scope.getNameTitle = function () {
			var defaultTitle = $translate.instant("consent-step-title");
			return $scope.stepManager.step.title || defaultTitle;
		};

		$scope.initalize = function () {
			$scope.canAgree = true;
			if ($scope.stepManager.step.requiresScrollToBottom) {
				$scope.canAgree = false;
				var checkReviewFrameScroll = self.checkReviewFrameScroll;
				var checkMarkdownScroll = self.checkMarkdownScroll;

				if(!$scope.stepManager.step.consentMarkdown){
					var reviewFrame = $element.find(".review-frame");
					reviewFrame.on('load', function () {
						var reviewFrameDoc = self.getContentDocument();
						if (reviewFrameDoc) {
							reviewFrameDoc.addEventListener('scroll', checkReviewFrameScroll);
						}
						// check initially
						checkReviewFrameScroll();
					});
				} else {
					var markdownContainer = $element.find(".consent-markdown-container");
					markdownContainer[0].addEventListener('scroll', () => $scope.$apply(() => checkMarkdownScroll()));
					// check initially
					$timeout(checkMarkdownScroll);
				}

			}

			if (!$scope.stepManager.step.consentMarkdown) {
				var content = $scope.trustAsHtml($scope.stepManager.reviewFrameContent());
				var reviewFrameDoc = self.getContentDocument(reviewFrame);
				reviewFrameDoc.write(content);
				reviewFrameDoc.close();
				$(reviewFrameDoc).scrollTop(0);
			} 

			var signatureCanvas = $element.find('.signature-line');
			self.signaturePad = new SignaturePad(signatureCanvas[0]);
			self.signaturePad.addEventListener("endStroke", () => {
				$scope.$apply(function () {
					$scope.stepManager.updateSignatureImage(self.signaturePad.toDataURL());
				});
			});
		}

		$scope.clearSignature = function () {
			self.signaturePad.clear();
			$scope.stepManager.updateSignatureImage(null);
		}

		self.$onDestroy = function () {
			var contentDoc = self.getContentDocument();
			if (contentDoc) {
				contentDoc.removeEventListener("scroll", self.checkReviewFrameScroll);
			}
		}

		self.checkReviewFrameScroll = function () {
			var reviewFrame = $element.find(".review-frame");
			var contentDocument = self.getContentDocument(reviewFrame);
			if (($(contentDocument).scrollTop() + reviewFrame.outerHeight()) >= $(contentDocument.body).outerHeight()) {
				$scope.$apply(function () {
					$scope.canAgree = true;
				});
			}
		}

		self.checkMarkdownScroll = function () {
			var content = $element.find(".consent-markdown-container");
			if(content[0].scrollHeight === 0) {
				// Content not loaded.
				return;
			}
			if(content.scrollTop() + content.outerHeight() + 1 >= content[0].scrollHeight) {
				$scope.canAgree = true;
			}
		}

		self.getContentDocument = function (reviewFrame) {
			if (!reviewFrame) {
				reviewFrame = $element.find(".review-frame");
			}
			var reviewFrameDoc;
			if (reviewFrame[0].contentDocument) {
				reviewFrameDoc = reviewFrame[0].contentDocument;
			}
			else if (reviewFrame[0].contentWindow) {
				reviewFrameDoc = reviewFrame[0].contentWindow.document;
			}
			return reviewFrameDoc;
		}

		$scope.nameFormItems = function () {
			let signature = $scope.stepManager.signature();
			if (!signature || !signature.requiresName) { return []; }

			return getTypedNameFormItems({
				"first-name-label": $translate.instant("first-name-label"),
				"last-name-label": $translate.instant("last-name-label"),
				"required-field-placeholder": $translate.instant("required-field-placeholder")
			});
		}

		$scope.nameChildResults = function () {
			let signature = $scope.stepManager.signature();
			if (!signature || !signature.requiresName) { return []; }
			let signatureResult = $scope.stepManager.getChildResult(signature.identifier);

			return [
				{
					Identifier: "FirstName",
					Answer: signatureResult?.Signature?.GivenName || ""
				},
				{
					Identifier: "LastName",
					Answer: signatureResult?.Signature?.FamilyName || ""
				}
			]
		}

		$scope.onNameResultChange = function (result) {
			let signature = $scope.stepManager.signature();
			if (!signature || !signature.requiresName) { return []; }
			let signatureResult = $scope.stepManager.getChildResult(signature.identifier);
			if (!signatureResult) { return []; }

			$scope.$apply(function () {
				if (result.Identifier == "FirstName") {
					signatureResult.Signature.GivenName = result.Answer;
				}
				else if (result.Identifier == "LastName") {
					signatureResult.Signature.FamilyName = result.Answer;
				}
				$scope.stepManager.resultDidChange();
			});
		}
	}
]);

module.factory("ConsentReviewStepManager", ["$translate", "StepManager", function ($translate, StepManager) {
	function ConsentReviewStepManager(step, surveyManager) {
		StepManager.call(this, step, surveyManager);
		this.consentReviewStepIndex = 0;
	}
	ConsentReviewStepManager.prototype = Object.create(StepManager.prototype);

	ConsentReviewStepManager.prototype.initializeResults = function (previousResult) {
		StepManager.prototype.initializeResults.call(this, previousResult);
		var signature = this.signature();
		if (!signature) {
			this.childResults = [{
				Identifier: "NoSignature",
				Type: "ConsentSignatureResult",
				StartDate: this.presentedDate,
				Signature: {
					Identifier: "NoSignature",
					GivenName: "",
					FamilyName: "",
					PDFNameLineLabel: this.step.pdfNameLineLabel,
					PDFSignatureLineLabel: this.step.pdfSignatureLineLabel,
				}
			}];
		} else {
			this.childResults = [{
				Identifier: signature.identifier,
				Type: "ConsentSignatureResult",
				StartDate: this.presentedDate,
				Signature: {
					Identifier: signature.identifier,
					GivenName: signature.givenName,
					FamilyName: signature.familyName,
					Title: signature.title,
					PDFNameLineLabel: this.step.pdfNameLineLabel,
					PDFSignatureLineLabel: this.step.pdfSignatureLineLabel,
				}
			}];
		}
		if (this.step.autoAgree) {
			this.childResults[0].Consented = true;
		}
	}

	ConsentReviewStepManager.prototype.hasEnteredName = function () {
		if (this.signature()) {
			var result = this.getChildResult(this.signature().identifier);
			var givenName = result.Signature.GivenName;
			var familyName = result.Signature.FamilyName;
			if (givenName && givenName.length && familyName && familyName.length) {
				return true;
			}
		}
		return false;
	}

	ConsentReviewStepManager.prototype.disagree = function () {
		this.childResults[0].Consented = false;
		StepManager.prototype.continue.call(this);
	}

	ConsentReviewStepManager.prototype.agree = function () {
		if (this.step.reasonForConsent) {
			if (window.confirm(this.step.reasonForConsent)) {
				this.childResults[0].Consented = true;
				this.continue();
			}
		}
		else {
			this.childResults[0].Consented = true;
			this.continue();
		}
	}

	ConsentReviewStepManager.prototype.reviewFrameContent = function () {
		var titleStyle = {
			"white-space": "pre-wrap",
			"font-size": "29px",
			"text-align": "center",
			"font-weight": "normal",
			"color": "black"
		};
		var titleStyle = _.map(_.extend(titleStyle, _.pick(this.getTextStyles('title'), _.identity)), function (v, k) { return `${k}:${v}` }).join(';');

		var styleblock = "<style type='text/css'> body { font-family: Helvetica, Arial; color:#333; padding:10px 20px 20px 20px; margin-top: 0; margin-left:0; overflow:auto, line-height:1.3 } ";
		if (this.getHideDefaultHeader()) {
			styleblock += "header { " + titleStyle + " }";
		} else {
			styleblock += "header { font-weight: bold }";
		}
		styleblock += "</style>";
		var consentDocument = this.consentDocument();
		var html = "";
		if (consentDocument) {
			html += "<header>" + consentDocument.title + "</header>";

			for (var i = 0; i < consentDocument.sections.length; i++) {
				var section = consentDocument.sections[i];
				html += "<p><strong>";
				if (section.formalTitle && section.formalTitle.length) {
					html += section.formalTitle;
				} else {
					html += section.title
				}
				html += "</strong></p>";
				if (section.htmlContent && section.htmlContent.length) {
					html += section.htmlContent;
				} else if (section.content) {
					html += "<p>" + section.content + "</p>";
				}
			}
		}

		let sanitizedHtml = $.parseHTML(DOMPurify.sanitize(html));
		var $sanitizedHtml = $('<div />', { html: sanitizedHtml });
		$sanitizedHtml.find("a").attr("target", "_blank");
		return styleblock + $sanitizedHtml.html();
	}

	ConsentReviewStepManager.prototype.consentHTML = function (signatureResult, consentDocument) {
		var stepManager = this;

		var html = this.reviewFrameContent();

		if (signatureResult.Identifier != "NoSignature") {
			html +=
				"<h1 style='page-break-before:always;'>" + (consentDocument.signaturePageTitle || "") + "</h1>" +
				"<div style='padding-bottom: 40px;'>" + (consentDocument.signaturePageContent || "") + "</div>";

			var nameCell = "<td style='width:33%'></td>";
			var nameLabelCell = "<td></td>"
			if (this.hasEnteredName()) {
				var consentPrintedNameLabel = signatureResult.PDFNameLineLabel || $translate.instant("consent-printed-name-label", { signatureLabel: signatureResult.Title || signatureResult.Identifier });
				nameCell = "<td style='border-bottom:1px solid black;width:33%;'>" + signatureResult.GivenName + ' ' + signatureResult.FamilyName + "</td>";
				nameLabelCell = "<td style='padding-top:5px;'>" + consentPrintedNameLabel + "</td>";
			}

			var signatureCell = "<td style='width:33%'></td>";
			var signatureLabelCell = "<td></td>"
			if (stepManager.signatureURL) {
				var consentSignatureLabel = signatureResult.PDFSignatureLineLabel || $translate.instant("consent-signature-label", { signatureLabel: signatureResult.Title || signatureResult.Identifier });
				signatureCell = "<td style='border-bottom:1px solid black;width:33%;'><img src='" + stepManager.signatureURL + "'/></td>";
				signatureLabelCell = "<td style='padding-top:5px;'>" + consentSignatureLabel + "</td>";
			}

			var consentDateLabel = $translate.instant("consent-date-label");
			html +=
				"<table style='width:100%;border-spacing: 40px 0px;'>" +
				"<tr style='vertical-align:bottom;'>" +
				nameCell +
				signatureCell +
				"<td style='border-bottom:1px solid black;width:33%;'>" + signatureResult.Date + "</td>" +
				"</tr>" +
				"<tr>" +
				nameLabelCell +
				signatureLabelCell +
				"<td style='padding-top:5px;'>" +
				consentDateLabel +
				"</td>" +
				"</tr>" +
				"</table>";
		}
		return html;
	}

	ConsentReviewStepManager.prototype.isLastStep = function () {
		return StepManager.prototype.isLastStep.call(this) && (this.consentReviewStepIndex == this.getPages().length - 1);
	}

	ConsentReviewStepManager.prototype.getPages = function () {
		var signature = this.signature();
		var pages = ['Review'];
		if (this.step.autoAgree) {
			pages = [];
		}
		if (signature) {
			if (signature.requiresName) {
				pages.push('Name');
			}

			if (signature.requiresSignatureImage && !signature.bypassSignatureOnWeb) {
				pages.push('Signature')
			}
		}
		return pages;
	}

	ConsentReviewStepManager.prototype.continue = function () {
		if (this.consentReviewStepIndex == this.getPages().length - 1) {
			var signature = this.signature();
			var consentDocument = this.consentDocument();
			let result = this.getChildResult(signature ? signature.identifier : "NoSignature");
			result.Signature.Date = getSignatureDate(this.step.signatureDateFormat);
			if(!this.step.consentMarkdown) {
				result.Signature.ConsentDocumentContent = this.consentHTML(result.Signature, consentDocument);
			} else {
				const markdownForm = getConsentMarkdownAsForm(this.step.consentDocumentTitle, this.step.consentMarkdown);
				if(signature) {
					markdownForm.formItems.push({
						identifier: result.Identifier,
						type: 'FormItem',
						answerFormat: {
							...signature,
							type: 'SignatureAnswerFormat',
							signatureTitle: signature.title,
							signatureIdentifier: signature.identifier,
							pdfNameLineLabel: result.Signature.PDFNameLineLabel,
							pdfSignatureLineLabel: result.Signature.PDFSignatureLineLabel,
						}
					});
				}
				const results = signature ? [{
					Identifier: result.Identifier,
					Signature: {
						...result.Signature,
						HandwrittenSignatureBase64: this.signatureURL
					}
				}] : [];
				result.Signature.ConsentDocumentContent = renderFormStepToHtml(this.surveyManager.template, markdownForm, results, $translate) ;
			}
			
			result.Signature.ConsentDocumentTitle = consentDocument.title;
			StepManager.prototype.continue.call(this);
		} else {
			this.consentReviewStepIndex++;
		}
	}

	ConsentReviewStepManager.prototype.currentPage = function () {
		return this.getPages()[this.consentReviewStepIndex];
	}

	ConsentReviewStepManager.prototype.back = function () {
		if (this.consentReviewStepIndex == 0) {
			StepManager.prototype.back.call(this)
		} else {
			this.consentReviewStepIndex--;
		}
	}

	ConsentReviewStepManager.prototype.consentDocument = function () {
		var step = this.step;
		if (step.type == 'ConsentReviewStep') {
			return _.find(this.surveyManager.template.consentDocuments, function (document) { return document.title == step.consentDocumentTitle });
		} else {
			return {
				'type': 'ConsentDocument',
				'title': step.consentDocumentTitle,
				'sections': _.map(step.sections, function (section) {
					return {
						type: 'ConsentSection',
						sectionType: 'Custom',
						title: section['title'],
						htmlContent: section['content']
					};
				}),
				'signatures': [
					{
						'type': 'ConsentSignature',
						'identifier': 'Participant',
						'title': !step.signatureTitle ? 'Participant' : step.signatureTitle,
						'requiresName': step.requiresName,
						'requiresSignatureImage': step.requiresSignatureImage,
						'bypassSignatureOnWeb': step.bypassSignatureOnWeb
					}
				]
			};
		}
	}

	ConsentReviewStepManager.prototype.signature = function () {
		var consentDocument = this.consentDocument();
		if (!consentDocument) { return null; }
		var step = this.step;
		if (step.type == 'ConsentReviewStep') {
			return _.find(consentDocument.signatures, function (signature) { return signature.identifier == step.signatureIdentifier });
		}
		else {
			return _.first(consentDocument.signatures);
		}
	}

	ConsentReviewStepManager.prototype.updateSignatureImage = function (dataURL) {
		this.signatureURL = dataURL;
	}

	ConsentReviewStepManager.prototype.hasSignature = function () {
		return !!this.signatureURL;
	}

	ConsentReviewStepManager.prototype.getDisableDisagree = function () {
		if (this.step.type == 'ConsentReviewStep') {
			return this.step.disableDisagree;
		}
		else if (this.step.type === 'ConsentStep') {
			return !this.step.provideDisagree;
		}

		return true;
	}

	ConsentReviewStepManager.prototype.getHideDefaultHeader = function () {
		if (this.step.type == 'ConsentReviewStep') {
			return this.step.hideDefaultHeader;
		}
		return true;
	}

	ConsentReviewStepManager.prototype.canGoBack = function () {
		return StepManager.prototype.canGoBack.call(this) || this.consentReviewStepIndex > 0;
	}

	return ConsentReviewStepManager;
}]);